function PageLayout({ title, className, children }) {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h6 className="back-home-button">
              <a className="partial-underline-sm" href="/">
                Home
              </a>
            </h6>
          </div>
        </div>
      </div>
      <div className="screen-swipe"></div>
      <div className={className}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="fade-in">{title}</h1>
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export default PageLayout;
